import { Button } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { DashLayout } from "../../../Components/DashLayout";

interface Props {
  onBack: () => void;
}

const RegistrationClosedState = ({ onBack }: Props) => {
  return (
    <DashLayout title="Registration Closed">
      <div className="rounded-lg bg-white p-6 shadow-sm shadow-black/25">
        <p>Registration for this competition is closed.</p>
        <Button onClick={onBack} className="mt-4">
          Back
        </Button>
      </div>
    </DashLayout>
  );
};

export default ApplicationView(RegistrationClosedState);
